/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'table-column-plus-before': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13 2a2 2 0 00-2 2v16a2 2 0 002 2h9V2h-9m7 8v4h-7v-4h7m0 6v4h-7v-4h7m0-12v4h-7V4h7M9 11H6V8H4v3H1v2h3v3h2v-3h3v-2z"/>'
  }
})
